"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUnload = void 0;
var _react = require("react");
var useUnload = function useUnload(enabled, cb) {
  (0, _react.useEffect)(function () {
    if (!enabled) {
      return;
    }
    var handler = function handler() {
      if (cb) {
        cb();
      }
    };
    window.addEventListener('unload', handler);
    return function () {
      return window.removeEventListener('unload', handler);
    };
  }, [enabled, cb]);
};
exports.useUnload = useUnload;